// extracted by mini-css-extract-plugin
export default {"logosContainer":"style_logosContainer__t+BtS","btn":"style_btn__pN4FR"};